import React from "react";
import "./Style.scss";

interface ICodeListViewProps {
  leftSide: React.ReactNode;
  rightSide: React.ReactNode;
}

export const CodeListView: React.FC<ICodeListViewProps> = ({ leftSide, rightSide }) => {
  return (
    <div className="result-list__code_view">
      <div className="result-list__code_view__rules">{leftSide}</div>
      <div className="result-list__code_view__divider"></div>
      <div className="result-list__code_view__rules_details">{rightSide}</div>
    </div>
  );
};
